// extracted by mini-css-extract-plugin
export var avatarContainer = "_hn-0";
export var avatarTypingWave = "_hn-i";
export var gray = "_hn-f";
export var green = "_hn-c";
export var icon = "_hn-9";
export var image = "_hn-1";
export var lg = "_hn-6";
export var md = "_hn-5";
export var presenceDot = "_hn-b";
export var red = "_hn-d";
export var sm = "_hn-4";
export var status = "_hn-a";
export var typingDot = "_hn-h";
export var typingPill = "_hn-g";
export var xl = "_hn-7";
export var xs = "_hn-3";
export var xxl = "_hn-8";
export var xxs = "_hn-2";
export var yellow = "_hn-e";